import { INameTranslation } from "../../core/model/translations/NameTranslation";
import { IIndexType } from "../../indexTypes/model/IndexType";
import {
  IIndexTypeGroup,
  TIndexTypeGroup
} from "../../indexTypes/model/IndexTypeGroup";
import IndexTypeGroupMapper from "../../indexTypes/service/IndexTypeGroupMapper";
import IndexTypeMapper from "../../indexTypes/service/IndexTypeMapper";
import { IOrganisationIndex } from "../model/OrganisationIndex";
import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";
import OrganisationIndexGroupMapper from "./OrganisationIndexGroupMapper";
import OrganisationIndexMapper from "./OrganisationIndexMapper";

export interface TOrganisationIndexTree {
  id: number;
  indexTypeCategoryId: number;
  indexTypeGroupList: IIndexTypeGroup[];
  indexTypeList: IIndexType[];
  name: string;
  organisationId: number;
  organisationIndexGroups: IOrganisationIndexGroup[];
  organisationIndexList: IOrganisationIndex[];
  valid: boolean;

  nameTranslations: INameTranslation[];
}

export interface TOrganisationIndexResponse {
  id: number;
  indexTypeCategoryId: number;
  indexTypeGroupList: any[];
  indexTypeList: any[];
  name: string;
  nameTranslations: INameTranslation[];
  organisationId: number;
  organisationIndexGroups: any[];
  organisationIndexList: any[];
  valid: string;
}

const enrichIndexes = (
  indexTypes: IIndexType[],
  indexList: IOrganisationIndex[]
) => {
  return indexList?.map((item) => {
    item.type = indexTypes.find((type) => type.id === item.indexTypeId);
    return item;
  });
};
const enrichGroups = (
  groupTypes: TIndexTypeGroup[],
  groups: IOrganisationIndexGroup[],
  indexList: IOrganisationIndex[]
) => {
  return groups?.map((group) => {
    group.groupType = groupTypes.find(
      (item) => item.id === group.indexTypeGroupId
    );
    group.organisationIndexList = indexList.filter(
      (item) => item.organisationGroupId === group.id
    );
    return group;
  });
};
const enrichGroupTypes = (
  groupTypes: IIndexTypeGroup[],
  groups: IOrganisationIndexGroup[],
  items: IIndexType[]
) => {
  return groupTypes?.map((groupType) => {
    let filteredGroups = groups.filter(
      (item) => item.indexTypeGroupId === groupType.id
    );
    groupType.organisationIndexGroupList = filteredGroups;
    groupType.items = items.filter((item) =>
      groupType.indexTypeIds?.includes(item.id)
    );

    return groupType;
  });
};

const getAllIds = (elements: number[][]) => {
  return Array.prototype.concat.apply([], elements);
};

const collectGroupTypes = (groupTypes: IIndexTypeGroup[]) => {
  let _groups: IIndexTypeGroup[] = [];
  let chidlIdsList = getAllIds(groupTypes?.map((item) => item.childIds));
  _groups = groupTypes.filter((item) => !chidlIdsList?.includes(item.id));

  _groups.forEach((groupType) => {
    recursiveCall(groupTypes, groupType);
  });
  return _groups;
};
const recursiveCall = (
  groupTypes: IIndexTypeGroup[],
  groupType: IIndexTypeGroup,
  brojPom?: number
) => {
  if (groupType.childIds?.length > 0) {
    groupType.childGroups = groupTypes.filter(
      (item) =>
        groupType.childIds?.includes(item.id) && groupType.id !== item.id
    );

    groupType.childGroups.map((item) =>
      recursiveCall(groupTypes, item, brojPom)
    );
  }

  return groupType;
};
const IndexTypeGroupTreeMapper = (model: TOrganisationIndexResponse) => {
  let {
    organisationIndexList,
    indexTypeGroupList,
    indexTypeList,
    organisationIndexGroups
  } = model;

  organisationIndexList = organisationIndexList?.map(OrganisationIndexMapper);
  indexTypeGroupList = indexTypeGroupList?.map(IndexTypeGroupMapper);
  indexTypeList = indexTypeList?.map(IndexTypeMapper);
  organisationIndexGroups = organisationIndexGroups?.map(
    OrganisationIndexGroupMapper
  );

  const indexes = enrichIndexes(indexTypeList, organisationIndexList);
  let collectedGroups = enrichGroups(
    indexTypeGroupList,
    organisationIndexGroups,
    indexes
  );
  let colletedGroupTypes = enrichGroupTypes(
    indexTypeGroupList,
    collectedGroups,
    indexTypeList
  );
  return collectGroupTypes(colletedGroupTypes);
};

export default IndexTypeGroupTreeMapper;
